import { App } from "../../ts/app";
import { Controller } from "../../ts/controller";
import { Logger } from "../../ts/utils/logger";

export class CookieBannerController extends Controller {
    consent: "granted" | "denied" | null = null;

    constructor() {
        super({
            logLabel: "CookieBannerController",
        });
    }

    public initialize(): void {
        const consentRaw = localStorage.getItem("cookieConsent");
        if (consentRaw === "granted" || consentRaw === "denied") {
            this.consent = consentRaw;
        } else {
            this.consent = null;
        }
        this._initializeGTag();
        this._initListeners()
        this._setState();
        Logger.info(this.logLabel, "Initialized");
    }

    private _setState() {
        const banner = this.getElementByIdOrWarn("cookie-banner");
        if (banner) {
            banner.hidden = this.consent !== null;
        }
    }

    private _initializeGTag() {
        if (App.mockAds) {
            Logger.info(this.logLabel, 'In mock mode, not initiating the real ads');
            return;
        }
        this._updateGTagConsent();
    }

    private _initListeners() {
        this.bindClick({
            elementId: "cookie-banner-accept-cookies",
            handler: this._acceptCookies.bind(this),
        })
        this.bindClick({
            elementId: "cookie-banner-reject-cookies",
            handler: this._rejectCookies.bind(this),
        })
    }

    private _updateGTagConsent() {
        const consent = this.consent ?? "denied";
        gtag('consent', 'update', {
            'ad_storage': consent,
            'analytics_storage': consent,
            'ad_user_data': consent,
            'ad_personalization': consent
        });
    }

    private _acceptCookies() {
        localStorage.setItem("cookieConsent", "granted");
        this.consent = "granted";
        if (App.mockAds) {
            Logger.info(
                this.logLabel,
                `Set cookieConsent ${this.consent}, but in mock mode, not calling gtag() method`
            );
        }
        else {
            this._updateGTagConsent();
        }
        this._setState();
    }

    private _rejectCookies() {
        localStorage.setItem("cookieConsent", "denied");
        this.consent = "denied";
        if (App.mockAds) {
            Logger.info(
                this.logLabel,
                `Set cookieConsent ${this.consent}, but in mock mode, not calling gtag() method`
            );
        }
        else {
            this._updateGTagConsent();
        }
        this._setState();
    }
}